import { useState } from 'react';
import c from '../../styles/auth.module.css';

// A password input with a Show/Hide toggle. Each field manages its own
// reveal state so toggling one doesn't expose the others.
function PasswordField({ id, label, value, onChange, autoComplete, autoFocus }) {
  const [show, setShow] = useState(false);
  return (
    <div className={c.field}>
      <label className={c.label} htmlFor={id}>{label}</label>
      <div style={{ position: 'relative' }}>
        <input
          id={id}
          className={c.input}
          type={show ? 'text' : 'password'}
          autoComplete={autoComplete}
          placeholder="••••••••"
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          style={{ paddingRight: 60 }}
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? 'Hide password' : 'Show password'}
          style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', color: 'inherit', fontSize: 12, fontFamily: 'inherit', cursor: 'pointer', opacity: 0.7, padding: 0 }}
        >
          {show ? 'Hide' : 'Show'}
        </button>
      </div>
    </div>
  );
}

export function ResetPasswordForm({ target, isSelf, onReset, light, onClose }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');
  const [isLoading, setLoading] = useState(false);

  const name = `${target?.firstName || ''} ${target?.lastName || ''}`.trim() || 'this account';

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    const result = await onReset(password);
    setLoading(false);
    if (result.status === 'success') {
      setSuccess('Password updated');
      if (onClose) {
        setTimeout(() => onClose(), 10000);
      }
    } else {
      setLoading(false);
      setError(result.message || 'Failed to reset password');
    }
  };

  return (
    <form className={`${c.card} ${light ? c.lightCard : ''}`} onSubmit={onSubmit} style={{ maxWidth: 'none', margin: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <div className={c.title} style={{ margin: 0 }}>
          {isSelf ? 'Reset your password' : `Reset password — ${name}`}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{ background: 'transparent', border: 'none', color: 'inherit', fontSize: 20, lineHeight: 1, cursor: 'pointer' }}
          >
            ✕
          </button>
        )}
      </div>

      {error && <div className={c.error}>{error}</div>}
      {success && <div className={c.error} style={{ background: 'var(--success-wash)', borderColor: 'var(--success-ring)', color: 'var(--success)' }}>{success}</div>}

      <PasswordField
        id="newPassword"
        label="New Password"
        autoComplete="new-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <PasswordField
        id="confirmPassword"
        label="Confirm Password"
        autoComplete="new-password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
      />

      <button className={c.button} type="submit" disabled={isLoading || success}>
        {isLoading ? success ? 'Password updated!' : 'Saving…' : 'Reset Password'}
      </button>
    </form>
  );
}
